import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ChannelMemberAppResource from './ChannelMemberAppResource';
import MessageAppResource from './MessageAppResource';

class MessageChannelMemberReadAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'message-channel-member-read';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'messages/channels/members/reads';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'channelMemberUuid',
            'messageUuid',
            'channelMember',
            'message',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            channelMember: ChannelMemberAppResource,
            message: MessageAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            channelMember: 'channel_member_uuid',
            message: 'message_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            channelMemberUuid: {
                type: 'string',
                presence: true,
            },
            messageUuid: {
                type: 'string',
                presence: true,
            },
        };
    }

}

export default MessageChannelMemberReadAppResource;
